import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import {IAppConfig } from "../App_v01_Interfaces";


interface AppConfigProps{
  appConfig: IAppConfig;
}//end:



export const NavBar_v03Responsive_SUNDANCE_VENDING: React.FC<AppConfigProps> = ({appConfig}) => {
  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        {/* LOGO with responsive swap */}
        <Navbar.Brand href="/">
          {/* Large screen logo */}
          <img
            src={appConfig.images[0].imagePath + "LogoDesktop.png"}
            alt={appConfig.companyDisplayName}
            className="desktopLogoCSS1"
          />
          {/* Small screen logo */}
          <img     
            src={appConfig.images[0].imagePath + "LogoPhone.png"}
            alt={appConfig.companyDisplayName}
            className="phoneLogoCSS1"
          /> 

        </Navbar.Brand>

        {/* Toggle button for mobile menu */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
    
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/products">Products</Nav.Link>
            <Nav.Link href="/faq">FAQ</Nav.Link>
            <Nav.Link href="/contact">Contact</Nav.Link>
            <Nav.Link href="/about">About</Nav.Link>
          </Nav>
        </Navbar.Collapse> 
        
       
      </Container>
    </Navbar>
  );
};

export default NavBar_v03Responsive_SUNDANCE_VENDING;






        //=====================  park it


        {/* <img
            src="./SundanceLogoAndLettersWT.png"
            alt={appConfig.companyDisplayName}
            title={appConfig.companyLegalName}
          /> */}



        {/* src="/sundance-images/SundanceLogoDesktop.png" 
            src="/sundance-images/SundanceLogoPhone.png"
        */}
        